
/** * Looks up, sniffs and returns information around centra markets. getAllMarkets
 * is dispatched in nuxtServerInit to make this information readily available
 * to the client when it selects which market to display.
 *
 * A market is an aggregated representation of catalog and inventory. Language
 * and currency is secondary to this.
 */
export default {
  namespaced: true,
  state () {
    return {
      markets: [] // Should contain all markets
    }
  },
  mutations: {
    markets (state, markets) {
      state.markets = markets
    }
  },
  actions: {
    /**
     * Stores all markets in the state
     */
    lookupMarkets ({ state, commit, rootState, dispatch }) {
      return this.$backendApi.get('/markets').then((response) => {
        const markets = response.data
        commit('markets', markets)
      })
    }

  }
}
